export const PLAYER_KEYS = ["playerOne", "playerTwo", "playerThree", "playerFour"];

export const START_DATA = [
    { name: "Money", playerOne: 0, playerTwo: 0, playerThree: 0, playerFour: 0 },
    { name: "Viziers", playerOne: 0, playerTwo: 0, playerThree: 0, playerFour: 0 },
    { name: "Elders", playerOne: 0, playerTwo: 0, playerThree: 0, playerFour: 0 },
    { name: "Djins", playerOne: 0, playerTwo: 0, playerThree: 0, playerFour: 0 },
    { name: "Palm Trees", playerOne: 0, playerTwo: 0, playerThree: 0, playerFour: 0 },
    { name: "Palaces", playerOne: 0, playerTwo: 0, playerThree: 0, playerFour: 0 },
    { name: "Camels", playerOne: 0, playerTwo: 0, playerThree: 0, playerFour: 0 },
    { name: "Resources", playerOne: 0, playerTwo: 0, playerThree: 0, playerFour: 0 }
];

export const ROW_COLORS = [
    "money-row-color",
    "vizier-row-color",
    "elder-row-color",
    "djin-row-color",
    "palm-row-color",
    "palace-row-color",
    "camel-row-color",
    "resource-row-color"
];

export function createFreshData() {
    return START_DATA.map(row => ({ ...row }));
}

export function createFreshTotal() {
    return { name: "Total", playerOne: 0, playerTwo: 0, playerThree: 0, playerFour: 0 };
}

export const DEFAULT_NAMES = ["1", "2", "3", "4"];

const STORAGE_KEY = "five-tribes-scores";

export function loadFromStorage() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
            return JSON.parse(raw);
        }
    } catch {
        // ignore corrupted data
    }
    return null;
}

export function saveToStorage(data, playerNames, playerCount) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ data, playerNames, playerCount }));
    } catch {
        // storage full or unavailable
    }
}
